import { useContext, useEffect } from "react";

import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { NotificationContext } from "components/Notification/NotificationContext";
import { fetchApi } from "utils/baseFetcher";
import { apiBaseUrl, apiToken } from "utils/envVariables";
import { setSessionCookies } from "utils/setSessionCookies";

import style from "./style.module.scss";

const LinkedInButton = ({
  type,
  previewPassInterest,
  insightId,
  entityId,
  accountId,
  companyId,
  customButton,
}: any) => {
  const { setNotification } = useContext(NotificationContext);

  const linkedinAuthUrl = () => {
    const params: any = {};

    if (insightId) {
      params["source_type"] = "Insight";
      params["source_id"] = insightId;
    }
    if (entityId) {
      params["source_type"] = "Entity";
      params["source_id"] = entityId;
    }
    if (accountId) {
      params["source_type"] = "Account";
      params["source_id"] = accountId;
    }
    if (companyId) {
      params["source_type"] = "Company";
      params["source_id"] = companyId;
    }

    if (previewPassInterest) {
      params.interest = previewPassInterest;
    }

    if (type === "link") {
      params["link-account"] = true;
    }

    const paramStr = new URLSearchParams(params).toString();

    return `${apiBaseUrl}/api/v2/linkedin/auth?${paramStr}`;
  };

  const onMessage = async (event: any) => {
    try {
      const data = JSON.parse(event.data);
      if (type === "link") {
        if (data.linkedinId && data.linkToken) {
          fetch(`${apiBaseUrl}/api/v2/linkedin/link-account`, {
            method: "PATCH",
            headers: {
              "API-TOKEN": apiToken,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              "linkedin-id": data.linkedinId,
              "link-token": data.linkToken,
            }),
          })
            .then(() => {
              setNotification(
                "Your account is linked successfully.",
                "success"
              );
            })
            .catch((error) => {
              setNotification(error, "error");
            });
        }
      } else if (data.token) {
        const accountId = data?.account_id;

        if (!accountId) return;

        await setSessionCookies(data, {
          registerDevice: true,
        });

        const account = await fetchApi(
          `/api/v2/accounts/${accountId}?include=company`
        );
        if (account?.interfaceSetting?.requiresOnboarding) {
          localStorage.setItem("firstLogin", "true");
        } else if (localStorage.getItem("firstLogin")) {
          localStorage.removeItem("firstLogin");
        }

        window.location.reload();
      } else if (data.existing_account) {
        setNotification("Your account already exists in our system", "error");
      }
    } catch (error) {
      // do nothing;
    }
  };

  useEffect(() => {
    window.addEventListener("message", onMessage, false);

    return () => {
      window.removeEventListener("message", onMessage, false);
    };
  });

  const handleSignIn = () => {
    window.open(
      linkedinAuthUrl(),
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
  };

  if (customButton) {
    return customButton(handleSignIn);
  }

  return (
    <button className={style.btn_linkedin} onClick={handleSignIn}>
      <FontAwesomeIcon icon={faLinkedinIn} />
      Sign Up with LinkedIn
    </button>
  );
};

export default LinkedInButton;
